(() => {
  const widgetClass = '.gfa-widget.GSC-lXqxUVSUJTtkSfv';
  const replacements = [
    ['OVER 500.000+ TATTOOS WORN EUROPE-WIDE', 'PŘES 500 000 TETOVÁNÍ NOSENÝCH PO CELÉ EVROPĚ'],
    ['VISIT US', 'NAVŠTIVTE NÁS'],
    ['Looks like a real one', 'Vypadá jako skutečné tetování'],
    ['Looks just like a real one!', 'Vypadá jako skutečné tetování!'],
    ['Looks just like a real tattoo', 'Vypadá jako skutečné tetování'],
    ['Looks like a real tattoo', 'Vypadá jako skutečné tetování'],
    ['It looks too good', 'Vypadá skvěle'],
    ['Looks too good', 'Vypadá skvěle'],
    ['Find a pattern for yourself!', 'Najděte si svůj motiv!'],
    ['Stays on your skin for around 2 weeks', 'Vydrží na pokožce přibližně 2 týdny'],
    ['Lasts up to 2 weeks', 'Vydrží až 2 týdny'],
    ['New tattoo technology', 'Nová technologie tetování'],
    ['LET HIM COOK', 'NECHTE HO TVOŘIT'],
    ['LOOKS SO COOL', 'VYPADÁ SKVĚLE'],
    ['You have to try this!', 'Tohle musíte vyzkoušet!'],
    ['Our little prank works', 'Náš malý žert funguje'],
    ['THEY ACTUALLY LOOK REAL!!', 'OPRAVDU VYPADAJÍ JAKO SKUTEČNÉ!!'],
    ['Magic!', 'Kouzlo!'],
    ['Super realistic', 'Velmi realistické'],
    ['Plant-based dye', 'Rostlinné barvivo'],
    ['Looks seriously like a real tattoo', 'Vypadá opravdu jako skutečné tetování'],
    ['Would you try it?', 'Vyzkoušeli byste ho?'],
    ['A tattoo that lasts 2 weeks??', 'Tetování, které vydrží 2 týdny??'],
    ['semi-permanent tattoos made with a plant-based dye', 'polotrvalá tetování s rostlinným barvivem'],
    ['semi-permanent tattoos made with a plant- based dye', 'polotrvalá tetování s rostlinným barvivem'],
    ['semi-permanent tattoos made from plant-based dye', 'polotrvalá tetování s rostlinným barvivem'],
    ['Lasts on your skin for up to 2 weeks', 'Vydrží na pokožce až 2 týdny'],
    ['Trusted by tens of thousands of happy customers', 'Důvěřují nám desítky tisíc spokojených zákazníků'],
    ['Easy to apply - just 1 minute and you’re done!', 'Snadná aplikace - za 1 minutu je hotovo!'],
    ['Easy to apply - just 1 minute', 'Snadná aplikace - stačí 1 minuta'],
    ['Easy to apply - just 1 minute', 'Snadná aplikace - stačí 1 minuta'],
    ['Super easy to apply - 1 minute and done', 'Velmi snadná aplikace - za 1 minutu je hotovo'],
    ['Water-resistant. Rub-resistant. Life-resistant.', 'Odolné vůči vodě, tření a každodennímu životu.'],
    ['Water-resistant, gym-resistant and everyday-life-proof', 'Odolné vůči vodě, sportu a každodennímu životu'],
    ['Fast delivery across Europe!', 'Rychlé doručení po celé Evropě!'],
    ['Fast delivery', 'Rychlé doručení']
  ];
  const translate = (value) => replacements.reduce((text, pair) => text.split(pair[0]).join(pair[1]), value.replace(/[\u2013\u2014]/g, '-').replace(/semi-permanent tattoos made with a plant-\s*based dye/g, 'polotrvalá tetování s rostlinným barvivem'));
  let queued = false;
  const localize = () => {
    queued = false;
    document.querySelectorAll(widgetClass).forEach((widget) => {
      widget.querySelectorAll('h3, .gfa-content__button').forEach((element) => {
        const original = element.textContent;
        const localized = translate(original);
        if (original !== localized) element.textContent = localized;
      });
      widget.querySelectorAll('img[alt]').forEach((image) => {
        const original = image.getAttribute('alt');
        const localized = translate(original);
        if (original !== localized) image.setAttribute('alt', localized);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(localize);
  };
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['alt']});
  localize();
})();


